import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import Skeleton from "react-loading-skeleton";
import "swiper/css";
import "swiper/css/navigation";
import "react-loading-skeleton/dist/skeleton.css";
import "../style/heroBanner.css";
import { getherobanner } from "../service/herobanner.service";

const Herobanner = () => {
  const [topBanners, setTopBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deviceType, setDeviceType] = useState(
    window.innerWidth <= 768 ? "mobile" : "desktop"
  );

  useEffect(() => {
    fetchHeroBanner();

    const handleResize = () => {
      setDeviceType(window.innerWidth <= 768 ? "mobile" : "desktop");
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchHeroBanner = async () => {
    try {
      setLoading(true);

      const data = await getherobanner();

      // console.log("Hero Banner:", data);

      setTopBanners(data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getImage = (media = []) => {
    return (
      media.find((item) => item.deviceType === deviceType) ||
      media.find((item) => item.deviceType === "desktop") ||
      media.find((item) => item.deviceType === "mobile") ||
      {}
    );
  };

    // Hide section if API has no data
    
  if (!loading && !topBanners?.length) return null;

  return (
    <section className="Hero-Slider">
      <div className="container">
        <div className="banner-slider position-relative">
          <div className="swiper-button-prev custom-nav"></div>
          <div className="swiper-button-next custom-nav"></div>

          {loading ? (
            <Skeleton height={400} width="100%" />
          ) : (
            <Swiper
              modules={[Navigation, Autoplay]}
              navigation={{
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              }}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              loop={true}
              spaceBetween={10}
            >
              {topBanners.map((banner) => {
                const image = getImage(banner.media);

                return (
                  <SwiperSlide key={banner.id}>
                    <img
                      src={image.image}
                      alt={image.altText || banner.title}
                      className="img-fluid w-100"
                      style={{
                        width: "100%",
                        height: "auto",
                        objectFit: "cover",
                      }}
                    />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          )}
        </div>
      </div>
    </section>
  );
};
export default Herobanner;